import React, { useEffect } from 'react';
import styled from "styled-components";
import { useAuthApi } from "../hooks/api/axiosInterceptor";

const Container = styled.div`
    width: 100%;
    margin-bottom: 30px;
`;

const Table = styled.table`
    width: 100%;
    font-size: 14px;
    border-collapse: collapse;
    margin-top: 15px;
    table-layout: fixed;
`;

const Thead = styled.thead`
    background: #f5f6f6;
`;

const Tr = styled.tr`
    border-bottom: 1px solid #e3e3e3;
    
    &.notice {
        background-color: #f9f9f9;
    }
    
    &:hover {
        background-color: #f9f9f9;
    }
`;

const Th = styled.th`
    height: 45px;
    color: #444;
    padding: 10px;
    text-align: center;
    font-weight: 600;
    border-top: 2px solid #666;
    border-bottom: 1px solid #ddd;
`;

const Td = styled.td`
    height: 45px;
    padding: 10px;
    color: #666;
    text-align: center;
    vertical-align: middle;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    
    &.subject {
        text-align: left;
    }
    
    &.notice-label {
        font-weight: bold;
        color: #ff6600;
    }
`;
const EmptyMessage = styled.td`
    text-align: center;
    padding: 50px 0;
    color: #888;
`;

// 페이지네이션 스타일
const PaginationContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 20px;
`;

const PageButton = styled.button`
    width: 35px;
    height: 35px;
    margin: 0 3px;
    border: 1px solid ${props => props.active ? '#999' : '#ddd'};
    background-color: ${props => props.active ? '#f5f5f5' : 'white'};
    color: ${props => props.active ? '#333' : '#666'};
    cursor: pointer;
    border-radius: 3px;
    font-size: 13px;
    
    &:hover {
        background-color: ${props => props.active ? '#f5f5f5' : '#f9f9f9'};
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

const PageNavButton = styled(PageButton)`
    width: auto;
    padding: 0 10px;
`;

const MemberTable = ({
                         members = [],
                         loading = false,
                         currentPage = 1,
                         totalPages = 1,
                         onPageChange,
                         onCertifySuccess
                     }) => {

    const handleCertify = async (memberId) => {
        try {
            const response = await useAuthApi.post(`/admin/certify`, { id: memberId });

            if (response.data.result === "SUCCESS") {
                alert("허가 완료");
                if (onCertifySuccess) onCertifySuccess(); // optional callback
            } else {
                alert("허가 실패: " + response.data.message);
            }
        } catch (error) {
            console.error("허가 에러:", error);
            alert("허가 요청 중 오류가 발생했습니다.");
        }
    };

    if (loading) return <div>로딩 중...</div>;

    const renderPagination = () => {
        const pages = [];
        let startPage = Math.max(1, currentPage - 4);
        let endPage = Math.min(totalPages, currentPage + 5);
        if (endPage - startPage < 9 && totalPages > 10) {
            if (startPage === 1) endPage = Math.min(10, totalPages);
            else if (endPage === totalPages) startPage = Math.max(1, totalPages - 9);
        }

        pages.push(
            <PageNavButton key="first" onClick={() => onPageChange(1)} disabled={currentPage === 1}>처음</PageNavButton>,
            <PageNavButton key="prev" onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>이전</PageNavButton>
        );

        for (let i = startPage; i <= endPage; i++) {
            pages.push(<PageButton key={i} active={i === currentPage} onClick={() => onPageChange(i)}>{i}</PageButton>);
        }

        pages.push(
            <PageNavButton key="next" onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages}>다음</PageNavButton>,
            <PageNavButton key="last" onClick={() => onPageChange(totalPages)} disabled={currentPage === totalPages}>마지막</PageNavButton>
        );

        return pages;
    };

    return (
        <Container>
            <Table>
                <Thead>
                    <Tr>
                        <Th width="8%">NO</Th>
                        <Th width="20%">ID</Th>
                        <Th width="20%">이름</Th>
                        <Th width="20%">가입일자</Th>
                        <Th width="16%">이메일 인증</Th>
                        <Th width="16%">관리자 인증</Th>
                    </Tr>
                </Thead>
                <tbody>
                {members.length > 0 ? (
                    members.map((member, index) => (
                        <Tr key={member.id}>
                            <Td>{member.displayNumber || index + 1}</Td>
                            <Td>{member.id}</Td>
                            <Td>{member.name}</Td>
                            <Td>{member.createdAt}</Td>
                            <Td>{member.mailok === "Y" ? "완료" : "미완료"}</Td>
                            <Td>
                                {member.certify === 1 ? (
                                    "완료"
                                ) : (
                                    <button onClick={() => handleCertify(member.id)}>허가</button>
                                )}
                            </Td>
                        </Tr>
                    ))
                ) : (
                    <Tr>
                        <EmptyMessage colSpan="6">회원 정보가 없습니다.</EmptyMessage>
                    </Tr>
                )}
                </tbody>
            </Table>
            <PaginationContainer>{renderPagination()}</PaginationContainer>
        </Container>
    );
};

export default MemberTable;
